import { Heart, Award, BookOpen } from "lucide-react";
import heroImage from "@/assets/hero-couple.jpg";

export const HeroSection = ({ onStartQuiz }) => {
  return (
    <section className="relative min-h-[85vh] flex items-center justify-center overflow-hidden pt-16">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src={heroImage}
          alt="Serene couple practicing yoga at sunset"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-teal-dark/80 via-primary/75 to-primary/90" />
      </div>

      {/* Mandala Pattern Overlay */}
      <div className="absolute inset-0 mandala-bg opacity-30 z-10" />

      {/* Content */}
      <div className="container relative z-20 text-center px-4 py-8 md:py-12">
        <div className="max-w-4xl mx-auto animate-fade-up">
          {/* Coach Badge */}
          <div className="inline-flex items-center gap-2 bg-accent/20 backdrop-blur-sm rounded-full px-4 py-2 mb-6 border border-accent/30">
            <span className="text-sm text-primary-foreground/90">
              By <strong className="text-accent">Vinod Kumar</strong>, Relationship and Life WISDOM Coach
            </span>
          </div>

          {/* Main Headline */}
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-primary-foreground mb-6 leading-tight text-balance">
            Discover the Hidden Layers of Your Relationship in{" "}
            <span className="text-gradient-lime">3 Minutes</span>
          </h1>

          {/* Subheadline */}
          <p className="text-lg md:text-xl text-primary-foreground/85 max-w-3xl mx-auto mb-8 leading-relaxed text-balance">
            Take our free diagnostic quiz based on the{" "}
            <strong className="text-accent">Five Koshas</strong> (Annamaya, Pranamaya, Manomaya, 
            Vijnanamaya, Anandamaya) and <strong className="text-accent">Bhagavad Gita</strong> principles 
            to uncover strengths and imbalances in your relationship.
          </p>

          {/* CTA Button */}
          <button
            onClick={onStartQuiz}
            className="btn-lime text-lg md:text-xl px-10 md:px-12 py-4 md:py-5 animate-pulse-lime mb-10"
            data-testid="start-quiz-btn"
          >
            Start Free Diagnostic Now
          </button>

          {/* Trust Badges */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-primary-foreground/80">
            <div className="flex items-center gap-2">
              <Heart className="w-5 h-5 text-accent" />
              <span className="text-sm font-medium">For Couples Seeking Deeper Connection</span>
            </div>
            <div className="hidden sm:block w-px h-6 bg-primary-foreground/30" />
            <div className="flex items-center gap-2">
              <Award className="w-5 h-5 text-accent" />
              <span className="text-sm font-medium">Backed by Vedanta & Psychology</span>
            </div>
            <div className="hidden sm:block w-px h-6 bg-primary-foreground/30" />
            <div className="flex items-center gap-2">
              <BookOpen className="w-5 h-5 text-accent" />
              <span className="text-sm font-medium">Ancient Wisdom Applied</span>
            </div>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-float">
          <div className="w-6 h-10 rounded-full border-2 border-primary-foreground/40 flex items-start justify-center p-2">
            <div className="w-1.5 h-3 bg-accent rounded-full animate-bounce" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
